import React from "react";
import InputMask from "@mona-health/react-input-mask";

const TextInputMaskProcessoFormik = ({ formik, field, mask, placeholder, disabled, className = "form-control" }) => {
  const hasError = formik.touched[field] && formik.errors[field];

  return (
    <>
      <InputMask
        id={field}
        name={field}
        mask={mask}
        placeholder={placeholder}
        disabled={formik.isSubmitting || disabled}
        value={formik.values[field] || ""}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        className={`${className} ${hasError ? "is-invalid" : ""}`}
      />

      {hasError && <div className="invalid-feedback">{formik.errors[field]}</div>}
    </>
  );
};

export default TextInputMaskProcessoFormik;
